import { concat } from 'lodash';
import React, { FC } from 'react';
import CreateForm from '../../../../../../../../../components/ui-component/form-component/create-form/CreateForm';
import { useApplication } from '../../../../../../../../../context/ApplicationContext';
import { ALS_ERLEDIGT_MARKIEREN_LABEL, PLATZHALTER_TEXT } from '../../../../../../../../../lib/constants/constant';
import { FormStrucItem } from '../../../../../../../../../lib/types/types';
import { ForceTrue } from '../../../../../../../../../lib/validation/ValidationTypes';
import PruefAssistenz from '../../../../../../antrag-components/PruefAssistenz';
import ApplicationHeading from '../../../../../../application-heading/ApplicationHeading';
import { checkIfPruefAssitenzNeedsToValidate } from '../../../../../../application-helper-function/AppHelperfunctions';

// import schemas
import { checkReadOnlyInUeberarbeitung } from 'src/utils/helper';
import AntragSchema from '../../../../../../../../../lib/paths/antrag_FULL_Paths.json';
const P = AntragSchema.attributes;

const ProjektDurchfuehrungAntragKreativwirtschaft: FC<{ hasComment?: boolean }> = ({ hasComment }) => {
	const { application, setApplicationProperty, readOnly } = useApplication();
	const updatedReadOnly = checkReadOnlyInUeberarbeitung(application, readOnly, hasComment);

	return (
		<>
			<ApplicationHeading title='Projektdurchführung' description={PLATZHALTER_TEXT} />

			<PruefAssistenz
				statusPath={P.Projektbeschreibung_Kreativwirtschaft.schema.attributes.Pruefung_Projektdurchfuehrung_Pruefstatus.path}
				hinweisPath={P.Projektbeschreibung_Kreativwirtschaft.schema.attributes.Pruefung_Projektdurchfuehrung_Hinweis_Fuer_Den_Antragsteller.path}
				ueberarbeitetAmPath={P.Projektbeschreibung_Kreativwirtschaft.schema.attributes.Pruefung_Projektdurchfuehrung_Ueberarbeitet_Am.path}
				erledigtPath={P.Projektbeschreibung_Kreativwirtschaft.schema.attributes.Pruefung_Projektdurchfuehrung_Erledigt.path}
				formStruc={formStrucPruefAssistenz()}
			/>

			<CreateForm
				formStruc={formStrucFunktion()}
				formValues={application}
				updateFormValuesFunc={setApplicationProperty}
				readOnly={updatedReadOnly}
			/>
			<CreateForm
				formStruc={formStrucZugriffzahlen()}
				formValues={application}
				updateFormValuesFunc={setApplicationProperty}
				readOnly={updatedReadOnly}
			/>
		</>
	);
};

export default ProjektDurchfuehrungAntragKreativwirtschaft;

const formStrucPruefAssistenz = () => {
	let struc: FormStrucItem[] = [
		{
			fields: [
				{
					...P.Projektbeschreibung_Kreativwirtschaft.schema.attributes.Pruefung_Projektdurchfuehrung_Erledigt,
					label: ALS_ERLEDIGT_MARKIEREN_LABEL,
					validation: [{ validateFunction: ForceTrue }],
				},
			],
		},
	];
	return struc;
};
const formStrucFunktion = () => {
	let struc: FormStrucItem[] = [
		{
			fields: [
				{
					...P.Projektbeschreibung_Kreativwirtschaft.schema.attributes.Projektbeschreibung_Krea_0211735460_uehrung_Zeitplanung_Freitext,
					// validation: [{ validateFunction: NonRequired }],
				},
				P.Projektbeschreibung_Kreativwirtschaft.schema.attributes.Projektbeschreibung_Krea_0205369022_e_Ihre_Zielgruppen_Erreichen,
				{
					...P.Projektbeschreibung_Kreativwirtschaft.schema.attributes.Projektbeschreibung_Krea_0246886579_B_Durch_Flyer_Newsletter_Etc,
					// validation: [{ validateFunction: NonRequired }],
				},
				P.Projektbeschreibung_Kreativwirtschaft.schema.attributes.Projektbeschreibung_Krea_0095572004_s_Follower_Werden_Angestrebt,
			],
			userProps: { direction: 'column', columnToDivide: 1 },
		},
	];
	return struc;
};
const formStrucZugriffzahlen = () => {
	return [
		{
			fields: [P.Projektbeschreibung_Kreativwirtschaft.schema.attributes.Projektbeschreibung_Krea_0201758897_tream_Auf_You_Tube_Videos_Oa],
			userProps: { direction: 'column', columnToDivide: 1 },
		},
	];
};

export const getFormStrucProjektDurchfuehrungAntragKreativwirtschaft = (application: any) => {
	if (
		checkIfPruefAssitenzNeedsToValidate(
			application,
			P.Projektbeschreibung_Kreativwirtschaft.schema.attributes.Pruefung_Projektdurchfuehrung_Pruefstatus.path,
			P.Projektbeschreibung_Kreativwirtschaft.schema.attributes.Pruefung_Projektdurchfuehrung_Erledigt.path,
		)
	)
		return concat(formStrucPruefAssistenz(), formStrucFunktion());

	return concat(formStrucFunktion());
};
